import { type MutationHookOptions, useMutation } from "@apollo/client";
import { SetDefaultCountryAccessMutation } from "../graphql/mutations";
import type {
  SetDefaultCountryAccessMutationType,
  SetDefaultCountryAccessMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useSetDefaultCountryAccessMutation = (
  options?: MutationHookOptions<
    SetDefaultCountryAccessMutationType,
    SetDefaultCountryAccessMutationVariablesType
  >
) => {
  return useMutation<
    SetDefaultCountryAccessMutationType,
    SetDefaultCountryAccessMutationVariablesType
  >(SetDefaultCountryAccessMutation, options);
};
